import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import { VueDatePicker } from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/scss/app.scss"
import '@fortawesome/fontawesome-free/css/all.css'
import VueFeather from "vue-feather";
import VueApexCharts from "vue3-apexcharts";
import Breadcrumbs from './layout/breadCrumbs.vue';

import { createI18n } from 'vue-i18n'
import English from "./locales/en.json"
import لعربية from "./locales/ae.json"
import 简体中文 from "./locales/cn.json"
import Português from "./locales/pt.json"
import Français from "./locales/fr.json"
import Deutsch from "./locales/de.json"
import Español from "./locales/es.json"
const i18n = createI18n({
  legacy: false,
  // Fijamos el idioma por defecto a Español
  locale: 'Español',
  messages: {
    English,
    Español,
    Deutsch,
    Français,
    Português,
    简体中文,
    لعربية,
  },
})

createApp(App)
.use(store)
.use(router)
.use(i18n)
.use(Vue3Toastify, { autoClose: 2000, theme: 'colored' })
.component('Datepicker', VueDatePicker)
.component(VueFeather.name, VueFeather)
.component('Breadcrumbs', Breadcrumbs)
.component('apexchart', VueApexCharts)
.mount('#app')
